/* Header state: a single attribute on <html> once the page has moved, so CSS can switch the bar
   from transparent to glass. One passive listener, one frame per burst of scrolling. */
(() => {
  const root = document.documentElement;
  let queued = false;
  const update = () => { queued = false; root.toggleAttribute('data-dn-scrolled', window.scrollY > 12); };
  window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
  update();
})();
